export default "__VITE_ASSET__8235bd06__"